module.exports = __webpack_public_path__ + "static/media/1.e48a2731.svg";